import React, { Suspense } from 'react';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';

import { lazyWithRetry } from '../../utils/lazyWithRetry';

// Lazy load dashboard for code splitting
const Dashboard = lazyWithRetry(() => import('./components/Dashboard'));

/**
 * Dashboard Page
 * Main entry point for the dashboard feature
 */
export const DashboardPage: React.FC = () => {
  return (
    <Suspense fallback={<CenteredSpinner />}>
      <Dashboard />
    </Suspense>
  );
};

export default DashboardPage;
